var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBudgetsLightmode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5442 75.4558C10.4853 61.397 10.4853 38.603 24.5442 24.5442C38.603 10.4853 61.397 10.4853 75.4558 24.5442C89.5147 38.603 89.5147 61.397 75.4558 75.4558C75.2194 75.6923 74.9804 75.9248 74.7391 76.1533L64.8335 66.2477C65.0783 66.0238 65.3194 65.7933 65.5563 65.5563C74.1479 56.9648 74.1479 43.0352 65.5563 34.4437C56.9648 25.8521 43.0352 25.8521 34.4437 34.4437C25.8521 43.0352 25.8521 56.9648 34.4437 65.5563L24.5442 75.4558Z",
    fill: "#FC3165"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50C86 69.8823 69.8823 86 50 86C30.1177 86 14 69.8823 14 50C14 30.1177 30.1177 14 50 14C50.009 14 50.0181 14 50.0271 14L50 14V28C37.8497 28 28 37.8497 28 50C28 62.1503 37.8497 72 50 72C62.1503 72 72 62.1503 72 50C72 49.7994 71.9973 49.5994 71.992 49.4H85.9951C85.9984 49.5996 86 49.7996 86 50Z",
    fill: "#000433"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 28C46.134 28 43 24.866 43 21C43 17.134 46.134 14 50 14C53.866 14 57 17.134 57 21C57 24.866 53.866 28 50 28Z",
    fill: "#FC3165"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.99 56C75.124 56 71.99 52.866 71.99 49C71.99 45.134 75.124 42 78.99 42C82.856 42 85.99 45.134 85.99 49C85.99 52.866 82.856 56 78.99 56Z",
    fill: "#FC3165"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBudgetsLightmode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/budgets-lightmode.db9a31a3bca161dce7832491269f3745.svg";